import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { MonroneyLabelView } from "./MonroneyLabelView"

export interface GetMonroneyLabelByInventoryIdPathParams {
	inventoryId: string
}

export const getMonroneyLabelByInventoryIdRoute: ApiRoute<
	GetMonroneyLabelByInventoryIdPathParams,
	NoQueryParams,
	NoBody,
	MonroneyLabelView
> = {
	buildUrl: ({ inventoryId }) => `/monroney-label/${inventoryId}`,
	method: "get",
	path: "/monroney-label/:inventoryId",
}
